// React
import React, { useState } from "react";
import { useParams } from "react-router-dom";

// Components
import ListCompareModal from "../components/ListCompareModal";
import ListContainer from "../components/ListContainer";
import ListEditModal from "../components/ListEditModal";
import ListUploaderModal from "../components/ListUploaderModal";
import YNPUploaderModal from "../components/YNPUploaderModal";

// EventifyAPI
import * as EventifyAPI from "../libs/EventifyAPI";

export default function ListPage(appProps) {
  let { listid } = useParams();

  const [isListCompareModalOpen, setIsListCompareModalOpen] = useState(false);
  const [isListEditModalOpen, setIsListEditModalOpen] = useState(false);
  const [isListUploaderModalOpen, setIsListUploaderModalOpen] = useState(false);
  const [isYNPUploaderModalOpen, setIsYNPUploaderModalOpen] = useState(false);

  return (
    <div className="list-page">
      <ListContainer
        email={appProps.email}
        organizationid={appProps.organizationid}
        listid={listid}
        listEditModalAction={() => {setIsListEditModalOpen(true);}}
        listCompareModalAction={() => {setIsListCompareModalOpen(true);}}
        showYNPUploadModal={() => {setIsYNPUploaderModalOpen(true);}}
        showUploadListModal={() => {setIsListUploaderModalOpen(true);}}
      />

      <ListCompareModal
        email={appProps.email}
        organizationid={appProps.organizationid}
        visible={isListCompareModalOpen}
        onCancel={() => {setIsListCompareModalOpen(false);}}
        listId={listid}
      />

      <ListEditModal
        email={appProps.email}
        organizationid={appProps.organizationid}
        visible={isListEditModalOpen}
        onCancel={() => {setIsListEditModalOpen(false);}}
      />

      <ListUploaderModal
        listid={listid}
        visible={isListUploaderModalOpen}
        onCancel={() => {setIsListUploaderModalOpen(false);}}
      />

      <YNPUploaderModal
        email={appProps.email}
        organizationid={appProps.organizationid}
        visible={isYNPUploaderModalOpen}
        onCancel={() => {setIsYNPUploaderModalOpen(false);}}
      />

    </div>
  );
}
